module.exports = __webpack_public_path__ + "static/media/opus_ai.48615f0f.png";